/**
 * Copyright 2025 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT-0
 */

import { Box, Typography, Button, Paper } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

export default function Unauthorized() {
  const { logout, user } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <LockIcon
            sx={{
              fontSize: 80,
              color: 'error.main',
            }}
          />
        </Box>

        <Typography variant="h4" gutterBottom>
          Access Denied
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          You do not have permission to access the admin portal.
        </Typography>

        {user && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Logged in as: <strong>{user.username}</strong>
            <br />
            Your groups: <strong>{user.groups?.join(', ') || 'None'}</strong>
          </Typography>
        )}

        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Please contact your system administrator to request admin access.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleLogout}
          fullWidth
        >
          Sign Out
        </Button>
      </Paper>
    </Box>
  );
}
